import React from 'react';
import styles from './Index.module.css';
import { calculateFormProgress } from './ProgressCalculator';
// import { calculateFormProgress } from '../Utils/progressCalculator';

const ProgressBar = ({ studyData, currentSectionIndex, onNavigateToSection, formData }) => {
    if (!studyData || studyData.sections.length <= 1) return null;

    const completionPercentage = calculateFormProgress(studyData, formData);

    return (
        <div className={styles.progressSection}>
            <div className={styles.progressInfo}>
                <span className={styles.progressText}>
                    Section {currentSectionIndex + 1} of {studyData.sections.length}
                </span>
                <span className={styles.progressPercentage}>
                    {completionPercentage}% Complete
                </span>
            </div>

            <div className={styles.progressTimeline}>
                {studyData.sections.map((section, index) => (
                    <React.Fragment key={section.id}>
                        <button
                            onClick={() => onNavigateToSection(index)}
                            className={`${styles.progressDot} ${index <= currentSectionIndex ? styles.progressDotActive : ''} ${index === currentSectionIndex ? styles.progressDotCurrent : ''}`}
                            type="button"
                            title={`Section ${index + 1}: ${section.title}`}
                        >
                            {index < currentSectionIndex ? (
                                <svg viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                            ) : (
                                <span>{index + 1}</span>
                            )}
                        </button>
                        {index < studyData.sections.length - 1 && (
                            <div className={`${styles.progressLine} ${index < currentSectionIndex ? styles.progressLineActive : ''}`}></div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default ProgressBar;